// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"BenefitsModal_modalContent__27hsb","pseudoLink":"BenefitsModal_pseudoLink__24jr2","benefitsList":"BenefitsModal_benefitsList__1zzJi"};